define('presentation/settings/liveReceptionistScripts/viewModels/deactivateLiveReceptionistScriptModalViewModel',[
    'common/promises/promiseFactory',
], function() {
    return function(liveReceptionistScript) {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        self.liveReceptionistScript = liveReceptionistScript;

        self.activate = () => {
            return _promiseFactory.wait();
        };
    };
});
